export class InMemoryPublicCleavageDrawPileRepository {
    constructor() {
        this.publicCleavages = [];
    }
    isCleavageExistByTitle(cleavage) {
        return Promise.resolve(this.publicCleavages.some(publicCleavage => publicCleavage.title === cleavage.title));
    }
    addCleavage(cleavage) {
        this.publicCleavages.push(cleavage);
        return Promise.resolve();
    }
    nextCleavage() {
        return Promise.resolve(this.publicCleavages.shift());
    }
}
